import heapService from './heap.service';
// import pendo from './pendo.service;

export const agent = {
  heap: heapService,
  // pendo: pendo,
};

export default agent;
